import React, { useRef, useState } from "react";
import Select from "react-select";

// Components
import InputField from "../../Shared/inputField/inputField";
import ErrorMessage from "../../../../../Shared/error-message/errorMessage";


// Style
import Styles from "../../Shared/sharedStyles.module.scss";
import {
  buttonStyles,
  StyledButton,
} from "../../../../../Shared/button/button";
import dropDownStyles from "../../../../../Shared/dropDownStyles";

import { contactInfoParams } from "../../../../../constants/data";

// Functions
import {
  checkGSTIN,
  checkPAN,
  checkUnregisteredGST,
} from "../../../../../utils/validation";
import { getFinancialYears } from "../../../../../utils/getFinancialYears";
import { IdsGenerator } from "../../../../../utils/idGenerator";
import InputDropdown from "../../../../../Shared/input-dropdown/inputDropdown";

function GstinPopup({ handleResponse, name }: any) {
  const serviceName = name.replaceAll(" ", "").toLowerCase();
  const gstNumberRef = useRef<any>("");
  const errorObject = {
    gstNumberError: false,
    financialYearError: false,
    contactInfoError: false,
    consentError: false,
  };

  const financialYears = getFinancialYears(2018);

  // const checkerFunction = serviceName === "gstpan" ? checkPAN : checkGSTIN;

  const [error, setError] = useState({ ...errorObject });
  const [isChecked, setIsChecked] = useState(false);
  const [isDisabled, setIsDisabled] = useState(true);
  const [loading, setLoading] = useState(false);
  const [financialYear, setFinancialYear] = useState("");
  const [contactInfo, setContactInfo] = useState(true);

  function isValid() {
    if (
      serviceName === "gstpan" &&
      checkPAN(gstNumberRef.current.value.trim().toUpperCase())
    ) {
      setError(errorObject);
      return setIsDisabled(false);
    } else if (
      serviceName === "gstunregistered" &&
      checkUnregisteredGST(gstNumberRef.current.value.trim().toUpperCase())
    ) {
      setError(errorObject);
      return setIsDisabled(false);
    } else if (checkGSTIN(gstNumberRef.current.value.trim().toUpperCase())) {
      setError(errorObject);
      return setIsDisabled(false);
    }

    setError(() => ({
      ...error,
      gstNumberError: true,
    }));
    return setIsDisabled(true);
  }

  function handleCheck() {
    const gstNumber = gstNumberRef.current.value.toUpperCase();
    const consent = isChecked === true ? "Y" : "N";

    if (!isChecked) {
      setError(() => ({
        ...error,
        consentError: true,
      }));
      return false;
    }
    setLoading(true);
    if (serviceName === "gstverificationadvance")
      handleResponse(
        { gstNumber, financialYear, contactInfo, consent },
        setLoading
      );
    else handleResponse({ gstNumber, consent }, setLoading);
  }

  let productName = "";
  if (serviceName === "gstpan") {
    productName = "Business PAN Number";
  } else if (serviceName === "gstunregistered") {
    productName = "Unregister GST Number";
  } else {
    productName = "GSTIN Number";
  }
  return (
    <div className={`${Styles.content}`}>
      <div className={`${Styles.infoForm} pl-2`}>
        <hr />
        <p className="mt-2">Fill in the below details to run verification</p>
        <div className="d-flex flex-column">
          <div className="d-flex flex-column mb-4 ">
            <label className={`${Styles.label} flex-grow-1`}>
              {productName}
            </label>
            <InputField
              id={IdsGenerator({
                prefix: `${serviceName} popup`,
                id: "change",
                suffix: `${productName}`,
              })}
              onChange={isValid}
              maxLength={serviceName === "gstpan" ? 10 : 15}
              inputRef={gstNumberRef}
              isError={error.gstNumberError}
              purpose="forGst"
            />
            {error.gstNumberError && (
              <ErrorMessage>{`Please enter a valid ${productName}`}</ErrorMessage>
            )}
          </div>
          {serviceName === "gstverificationadvance" && (
            <div className="d-flex gap-2">
              <div className="d-flex flex-column mr-5">
                <label className={`${Styles.label} flex-grow-1`}>
                  Financial Year
                </label>

                <InputDropdown
                  id={IdsGenerator({
                    prefix: `${serviceName} popup`,
                    id: "select",
                    suffix: "year",
                  })}
                  optionsArray={
                    Array.isArray(financialYears) ? financialYears : []
                  }
                  click={(e: any) => {
                    setFinancialYear(e.value || e);
                  }}
                />

                {error.financialYearError && (
                  <ErrorMessage>Please provide financial Year!</ErrorMessage>
                )}
              </div>
              <div className="d-flex flex-column">
                <label className={`${Styles.label} flex-grow-1`}>
                  Contact Info
                </label>
                <Select
                  id={IdsGenerator({
                    prefix: `${serviceName} popup`,
                    id: "select",
                    suffix: "contact",
                  })}
                  options={contactInfoParams}
                  styles={dropDownStyles.customStylesForFinancialYears}
                  onChange={(e: any) => setContactInfo(e.value)}
                />
              </div>
            </div>
          )}
          <div className="pt-4 pl-4 pb-4 mt-4 d-flex flex-column">
            <div className="d-flex align-items-center py-0 gap-2">
              <input
                id={IdsGenerator({
                  prefix: `${serviceName} popup`,
                  id: "select",
                  suffix: "consent",
                })}
                data-testid={IdsGenerator({
                  prefix: `${serviceName} popup`,
                  id: "select",
                  suffix: "consent",
                })}
                type="checkbox"
                className={`${Styles.formCheckInput} `}
                onChange={(e: any) => {
                  setIsChecked(e.target.checked);
                  if (e.target.checked) {
                    setError((prev) => ({
                      ...prev,
                      consentError: false,
                    }));
                  }
                }}
              />
              <p className={`${Styles.ackText} mb-0`}>
                I hereby agree, to let zoop.one verify my data for verification
              </p>
            </div>
            {error.consentError && (
              <ErrorMessage>Please provide consent!</ErrorMessage>
            )}
          </div>
          <div className={`${Styles.buttonGroup}`}>
            <StyledButton
              id={IdsGenerator({
                prefix: `${serviceName} popup`,
                id: "click",
                suffix: "run verification",
              })}
              hoverStyle={{ ...buttonStyles.primary.hover }}
              disabled={isDisabled}
              isLoading={loading}
              style={{ ...buttonStyles.primary.normal }}
              onClick={() => {
                setTimeout(() => setError({ ...errorObject }), 2000);
                handleCheck();
              }}
            >
              Run Verification
            </StyledButton>
          </div>
        </div>
      </div>
    </div>
  );
}

export default GstinPopup;
